export default {
  getCourierScoreHome: '/courierScore/client/home',
  firstWatch: '/v3/grow/watch'
}
